class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

// Add 'js' class to body when JavaScript loads to help with CSS selectors
document.addEventListener('DOMContentLoaded', () => {
  document.body.classList.add('js');
});

class HeaderMenu extends HTMLElement {
  constructor() {
    super();
    console.log('HeaderMenu constructor called');
    this.header = document.querySelector('.header-wrapper');
    
    // Check if this is a mega menu (has mega-menu-container class)
    if (this.classList.contains('mega-menu-container')) {
      console.log('Initializing mega menu');
      this.initMegaMenu();
    } else {
      console.log('Initializing details disclosure');
      // Fall back to original details disclosure behavior
      this.initDetailsDisclosure();
    }
  }

  initMegaMenu() {
    this.trigger = this.querySelector('.mega-menu-trigger');
    this.content = this.querySelector('.mega-menu__content');
    this.button = this.querySelector('button');
    
    if (!this.trigger || !this.content || !this.button) return;

    // Immediately ensure mega menu is hidden on page load to prevent flash
    this.hideMegaMenu();
    
    // Add a small delay to ensure the page is fully loaded before enabling interactions
    setTimeout(() => {
      this.enableMegaMenu();
    }, 100);

    // Set up header positioning
    if (this.header) {
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
    }
  }

  enableMegaMenu() {
    let hideTimeout;
    
    const showMenu = () => {
      clearTimeout(hideTimeout);
      this.showMegaMenu();
    };
    
    const hideMenu = () => {
      clearTimeout(hideTimeout);
      hideTimeout = setTimeout(() => {
        this.hideMegaMenu();
      }, 300); // 300ms close delay
    };
    
    this.addEventListener('mouseenter', showMenu);
    this.addEventListener('mouseleave', hideMenu);

    // Set up keyboard navigation
    this.button.addEventListener('keydown', this.handleKeydown.bind(this));
    this.button.addEventListener('focus', showMenu);
    this.content.addEventListener('focusout', this.handleFocusOut.bind(this));
  }



  initDetailsDisclosure() {
    // Original details disclosure behavior for non-mega menus
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    // Hover delay behavior on desktop
    let hideTimeout;
    const isDesktop = () => window.innerWidth >= 990;

    const openMenu = () => {
      if (!isDesktop()) return;
      clearTimeout(hideTimeout);
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
    };

    const closeMenu = () => {
      if (!isDesktop()) return;
      clearTimeout(hideTimeout);
      hideTimeout = setTimeout(() => {
        this.close();
      }, 300); // 300ms closing delay
    };

    this.addEventListener('mouseenter', openMenu);
    this.addEventListener('mouseleave', closeMenu);
  }

  showMegaMenu() {
    if (!this.content) return;
    
    this.content.classList.add('is-open');
    this.button.setAttribute('aria-expanded', 'true');
    
    // Prevent header from hiding when mega menu is open
    if (this.header) {
      this.header.preventHide = true;
    }
  }

  hideMegaMenu() {
    if (!this.content) return;
    
    this.content.classList.remove('is-open');
    this.button.setAttribute('aria-expanded', 'false');
    
    // Allow header to hide again
    if (this.header) {
      this.header.preventHide = false;
    }
  }

  handleKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.showMegaMenu();
    } else if (event.key === 'Escape') {
      this.hideMegaMenu();
      this.button.focus();
    }
  }

  handleFocusOut(event) {
    // Check if focus is moving to an element outside the mega menu
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.hideMegaMenu();
      }
    }, 100);
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    if (this.mainDetailsToggle) {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    }
  }
}

customElements.define('header-menu', HeaderMenu);
